/**
 * TanStack Query hooks for `finance-revenue-widget`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	financeRevenueWidgetQueryKeys,
	type CreateFinanceRevenueWidgetBody,
	type ListFinanceRevenueWidgetResponse,
	type FinanceRevenueWidgetRow,
} from "./api";

export function useFinanceRevenueWidgetList(): UseQueryResult<ListFinanceRevenueWidgetResponse, Error> {
	return useQuery({
		queryKey: financeRevenueWidgetQueryKeys.list(),
		queryFn: list,
	});
}

export function useFinanceRevenueWidgetCreate(): UseMutationResult<FinanceRevenueWidgetRow, Error, CreateFinanceRevenueWidgetBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: financeRevenueWidgetQueryKeys.all });
		},
	});
}

export function useFinanceRevenueWidgetDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: financeRevenueWidgetQueryKeys.all });
		},
	});
}
